import React, { useState } from "react";
import { Badge, Col, Row, Form, Button, Spinner } from "react-bootstrap";
import PrivateApi from "../../../services/PrivateApiService";

/**
 * 
 * @param {about} props string ticket about
 * @param {selectedUser} param object of selected user
 * @param {user} param object logged user
 * @param {selectedBuilding} param object of selected building
 * @param {selectedElvs} param object of selected elvs
 * @param {selectedInvoices} param object of selected invoices
 * @param {selectedInvoiceType} param string selected invoice type
 * @param {selectedAnlage} param object of selected anlage
 * @param {body} param string of ticket body
 * @param {files} param list of files to be uploaded
 * @param {setStage} param string setter
 * @param {error} param string setter for api error
 * 
 * @returns 
 */
const SummaryTicketStage = (props) => {

    const API = new PrivateApi();
    const [ticketIsSaving, setTicketIsSaving] = useState(false);
    

    // open ticket
    const openTicketHandler = () => {
        setTicketIsSaving(true);
        var data = {about: props.about, user: props.selectedUser};
        data.body = props.body.replaceAll("\n", "<br/>");
        if (props.selectedBuilding !== null && props.selectedBuilding !== true && props.selectedBuilding !== false) {
            data.building = props.selectedBuilding;
        }
        if (props.selectedAnlage !== null) {
            data.anlage = props.selectedAnlage;
        }
        if (props.files.length > 0) data.files = props.files;
        if (props.about === "Rechnung (ENERGO, Lieferantenrechnung)") {
            data.invoiceType = props.selectedInvoiceType;
            data.invoices = props.selectedInvoices;
        }
        if (props.about === "Energieliefervertrag") {
            for (var i=0; i < props.selectedElvs.length; i++) {
                if (!Array.isArray(props.selectedElvs[0].x_anlage_id)) {
                    props.selectedElvs[0].x_anlage_id = [props.selectedElvs[0].x_anlage_id.id, props.selectedElvs[0].x_anlage_id.x_studio_field_mWMGR];
                }
            }
            data.elvs = props.selectedElvs;
        }
        if (props.about === "Notfall") {
            data.priority = true;
        }
        API.post_Ticket_hw(data)
            .then(res => {
                setTicketIsSaving(false);
                props.setStage('done');
            })
            .catch(err => {
                if (err.response.data.detail !== undefined) {
                    props.error(err.response.data.detail);
                } else {
                    props.error("Unbekantes Fehler");
                }
                setTicketIsSaving(false);
                props.setStage("error");
            })
    }

    return (
        <>
            <h5>Ticket zu: <span className={props.about === "Notfall" ? "text-danger" : "text-energo"}>{props.about}</span></h5>
            <Row className="mt-3">
                <Col xs="12">
                    <small>{props.selectedUser.name} @ {props.user.name}</small>
                </Col>
            </Row>
            <Row className="mt-3">
                {
                    props.about === "Anlagen" ? 
                    <>
                        <Col xs="6">
                            <small className="text-muted">Anlagenadresse</small>
                            <p>{props.selectedAnlage.x_adresse_kompakt}</p>
                        </Col>
                        <Col xs="6">
                            <small className="text-muted">Anlagennummer ENERGO</small>
                            <p>{props.selectedAnlage.x_studio_field_mWMGR}</p>
                        </Col>
                    </> :
                    props.about === "Energieliefervertrag" ?
                        <>
                            <Col xs="6">
                                <small className="text-muted">Ausgewählte Gebäude</small>
                                {
                                    props.selectedBuilding !== undefined ?
                                        props.selectedBuilding === null || props.selectedBuilding === true ?
                                            <p>Nicht relevant</p>
                                            :
                                            <p>{props.selectedBuilding.name}</p>
                                    :null
                                }
                            </Col>
                            <Col xs="6">
                                <small className="text-muted">Ausgewählte Energielieferverträge</small>
                                <br />
                                {props.selectedElvs === null || props.selectedElvs === true ?
                                    <p>Nicht relevant</p>
                                    :
                                    props.selectedElvs.map(selElv => (
                                        <Badge key={selElv.id} style={{ marginRight: "5px" }} bg="energo" className="animate-slide-left">{selElv.id}</Badge>
                                    ))
                                }
                            </Col>
                        </> :
                        props.about === "Rechnung (ENERGO, Lieferantenrechnung)" ?
                            <>
                                {props.selectedInvoices && props.selectedInvoices.length > 0 ?
                                    props.selectedInvoices.map(i => (
                                        i.invoice_type === "poolrechnung" ?
                                            <Row key={i.id}>
                                                <Col xs="4">
                                                    <small className="text-muted">Rechnungsart</small>
                                                    <p>Poolrechnung</p>
                                                </Col>
                                                <Col xs="4">
                                                    <small className="text-muted">Rechnungsnummer</small>
                                                    <p>{i.x_rechnungsnummer}</p>
                                                </Col>
                                                <Col xs="4">
                                                    <small className="text-muted">Rechnungsdatum</small>
                                                    <p>{new Date(i.create_date).toLocaleDateString('DE-de')}</p>
                                                </Col>
                                            </Row>
                                            :
                                            i.invoice_type === "abrechnung" ?
                                                <Row key={i.id}>
                                                    <Col xs="4">
                                                        <small className="text-muted">Rechnunsart</small>
                                                        <p>Energielieferant</p>
                                                    </Col>
                                                    <Col xs="4">
                                                        <small className="text-muted">Rechnungsnummer</small>
                                                        <p>{i.x_rechnungsnummer}</p>
                                                    </Col>
                                                    <Col xs="4">
                                                        <small className="text-muted">Rechnungsdatum</small>
                                                        <p>
                                                            {new Date(i.create_date).toLocaleDateString('DE-de')}
                                                        </p>
                                                    </Col>
                                                </Row>
                                                :
                                                <Row key={i.id}>
                                                    <Col xs="4">
                                                        <small className="text-muted">Rechnunsart</small>
                                                        <p>Unbekannt</p>
                                                    </Col>
                                                    <Col xs="4">
                                                        <small className="text-muted">Rechnungsnummer</small>
                                                        <p>{i.x_rechnungsnummer}</p>
                                                    </Col>
                                                    <Col xs="4">
                                                        <small className="text-muted">Rechnungsdatum</small>
                                                        <p>-</p>
                                                    </Col>
                                                </Row>
                                    ))
                                    :
                                    <Col xs="12">
                                        <p>Rechnung ist nicht relevant</p>
                                    </Col>
                                }
                            </>
                            : null
                }
            </Row>
            <Row className="mt-3">
                <Col xs="12">
                    <Form.Control style={{ height: "150px" }} value={props.body} as="textarea" disabled />
                </Col>
            </Row>
            {props.files.length > 0 ?
                <Row className="mt-3">
                    <Col xs="12">
                        {props.files.map(f => (
                            <small key={f.file_name}>
                                <Badge bg="secondary">{f.file_name}</Badge>
                            </small>
                        ))}
                    </Col>
                </Row>
                : null}
            <Row className="mt-3">
                <Col xs="12" className="text-end" hidden={ticketIsSaving}>
                    <Button onClick={() => props.setStage("default")} variant="warning">Zurücksetzen</Button> &nbsp;
                    <Button onClick={() => openTicketHandler()} className="btn-energo">Senden</Button>
                </Col>
                <Col xs="12" className="text-end" hidden={!ticketIsSaving}>
                    <Spinner animation="border" className="text-energo" />
                </Col>
            </Row>
        </>
    )
}

export default SummaryTicketStage;